import Route from '@/generated/classes/Route';
import { type Router } from 'vue-router'
import { Position } from '@/framework/base/helpers/ElementPosition';
import { RouteBuilder } from '@/generated/router/RouteBuilder';

export function goToModule (vRouter: Router, route: Route, coordinates?: Position | null): void {
  // eslint-disable-next-line
  const sRoute: any = vRouter;
  const module = route.module.toLowerCase();
  if (sRoute.currentRoute.name !== module && module != 'none') {
    CiRouter.setRouteChangedSelector(null);
    vRouter.push({ name: module });
  }
  CiRouter.setRouteChanged(route);
  CiRouter.setRoute(route);
}
export interface SelectSectionId {
  (id: number): void;
}

export interface RouteChanged {
  (route: Route): void;
}
export interface AddRoute {
  (route: Route): void;
}

export class CiRouter {
  private static route: Route | null = null;
  private static routeChanged: RouteChanged | null = null;

  
  public static setRouteChangedSelector (fct: RouteChanged | null): void {
    CiRouter.routeChanged = fct;
    if (CiRouter.routeChanged && CiRouter.route) {
      CiRouter.routeChanged(CiRouter.route);
    }
  }

  public static setRouteChanged (route: Route): void {
    if (CiRouter.routeChanged) {
      CiRouter.routeChanged(route);
    }
  }

  public static setRoute (value: Route | null): void {
    if (value) {
      RouteBuilder.setRoute(value);
    }
    CiRouter.route = value;
  }

  public static getRoute (): Route | null {
    return CiRouter.route;
  }

  public static addRouteSetter: AddRoute;
  public static setAddRoute (addRoute: AddRoute) {
    CiRouter.addRouteSetter = addRoute;
  }

  public static addRoute (route: Route) {
    CiRouter.addRouteSetter(route);
  }
}
